import React, { useCallback, useContext } from 'react';
import useTranslations from '../../../hooks/useTranslations';
import { FormContext, useField } from '../FormContext';
import SingleChoiceFieldView from '../view/SingleChoiceFieldView';

export const Options = {
  YES: 'Yes',
  NO: 'No'
};

const SingleChoiceFieldEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  options = [],
  annotations,
  ...fieldProps // for future development, know whe have this
}) => {
  const { validateField, onFormBuilderDefaultValueSaved = () => {} } =
    useContext(FormContext);
  const t = useTranslations();
  const onBtnClick = useCallback(
    btnVal => {
      let value2Set;
      if (value === btnVal) {
        value2Set = null;
      } else {
        value2Set = btnVal;
      }
      setValue(value2Set);
      validateField(internalId, value2Set);
      onFormBuilderDefaultValueSaved(value2Set);
    },
    [setValue, value]
  );

  const validator = useCallback(
    value => {
      value = value ? value : '';
      let error = '';

      if (required && value.trim() === '') {
        error = t('forms.fields.error.required');
      }

      return error;
    },
    [required]
  );

  useField(internalId, validator);

  let tooltips = {};
  if (annotations && annotations.tooltips) {
    tooltips = annotations.tooltips;
  }

  const viewProps = {
    options,
    onBtnClick,
    readOnly,
    tooltips,
    value,
    yesBtnVariant: value === Options.YES ? 'contained' : 'outlined',
    noBtnVariant: value === Options.NO ? 'contained' : 'outlined',
    internalId
  };

  return <SingleChoiceFieldView {...viewProps} />;
};

export default SingleChoiceFieldEngine;
